import {
    checkForPastDate,
    checkForPastTime,
    validateDate,
    validateEndTime,
    validateRepeatUntilDate,
    validateStartTime,
    validateUserEventType
} from './validationFunctions';

export const validateUserEvent = (newEntry) => {
    let newErrors = {};
    newErrors = validateUserEventType(newEntry.userEventTypeId, newErrors);
    newErrors = validateStartTime(newEntry.startTime, newEntry.endTime, newErrors);
    newErrors = validateEndTime(newEntry.endTime, newEntry.startTime, newErrors);

    newErrors = validateDate(newEntry.date, newErrors);
    if (newEntry.date) newErrors = checkForPastDate(newEntry.date, newErrors);

    if (!newErrors?.date?.error)
        newErrors = checkForPastTime(newEntry.date, newEntry.startTime, newErrors);

    if (newEntry.repeat !== 'NO_REPEAT')
        newErrors = validateRepeatUntilDate(newEntry.repeatUntilDate, newEntry.date, newErrors);

    return newErrors;
};
